import LoginForm from './LoginForm'
Vue.component('LoginForm', LoginForm)

import ChangePassword from './ChangePassword'
Vue.component('ChangePassword', ChangePassword)





// WEBPACK FOOTER //
// ./src/js/components/Forms/index.js